import clsx from 'clsx'
import { useState } from 'react'

import { Link } from '@wartek-id/link'

import styles from './ExpanderCard.module.css'

const ArrowIcon = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M7.41 8.58997L12 13.17L16.59 8.58997L18 9.99997L12 16L6 9.99997L7.41 8.58997Z"
      fill="currentColor"
    />
  </svg>
)

interface Props {
  children: React.ReactNode
  openText: string
  closeText?: string
  open?: boolean
  className?: string
}

export default function ExpanderCardInline({
  children,
  openText,
  closeText = '',
  className = '',
  open = false,
}: Props) {
  const [isOpen, setIsOpen] = useState(open)

  const toggleOpen = () => {
    setIsOpen(!isOpen)
  }

  return (
    <>
      <div className="flex items-center">
        <Link as="button" onClick={toggleOpen} underline={false}>
          <div
            className={clsx(
              'flex items-center font-bold',
              styles.expanderCard__text
            )}
          >
            {isOpen ? closeText : openText}
            <ArrowIcon
              className={clsx(styles.expanderArrow, isOpen && styles.active)}
            />
          </div>
        </Link>
      </div>

      <div
        style={{
          visibility: isOpen ? 'visible' : 'hidden',
        }}
        className={clsx(styles.expanderCard, isOpen && styles.open, className)}
      >
        {children}
      </div>
    </>
  )
}
